import { ErrorMessage, Field } from 'formik';

const Input = ({
  id,
  title,
  name,
  type = 'text',
  labelClassName = '',
  inputClassName = '',
  ...props
}) => {
  // checkbox
  if (type === 'checkbox') {
    return (
      <div className='flex items-center gap-1.5 lg:gap-3'>
        <Field
          className={`relative size-4 cursor-pointer appearance-none rounded-md border border-[#E4E4F9] after:invisible after:absolute after:start-1/2 after:top-1/2 after:ms-2 after:mt-1 after:size-6 after:-translate-y-1/2 after:text-sm after:text-white after:content-['✓'] checked:border-red-600 checked:bg-red-600 checked:after:visible max-lg:after:text-xs lg:size-5 lg:after:mt-0.5 ltr:after:-translate-x-1/2 rtl:after:translate-x-1/2 ${inputClassName}`}
          type='checkbox'
          name={name}
          id={name}
          {...props}
        />
        <label className={`cursor-pointer ${labelClassName}`} htmlFor={name}>
          {title} {props?.mandatory && <span className='text-red-600'>*</span>}
        </label>
        <ErrorMessage
          name={name}
          component='p'
          className='text-xs text-red-600 lg:text-sm'
        />
      </div>
    );
  }

  return (
    <div className='flex flex-col'>
      <label
        className={`cursor-pointer max-md:text-sm ${labelClassName}`}
        htmlFor={id}
      >
        {title} {props.mandatory && <span className='text-red-600'>*</span>}
      </label>
      <Field
        name={name}
        id={id}
        className={`mt-1 flex-1 rounded-lg border border-[#E4E4F9] px-2 py-1.5 outline-none max-lg:text-sm max-lg:placeholder:text-sm max-md:text-[15px] max-md:placeholder:text-[15px] max-sm:text-sm max-sm:placeholder:text-sm ${inputClassName}`}
        {...props}
      />
      <ErrorMessage
        name={name}
        component='p'
        className='text-xs text-red-600 lg:text-sm'
      />
    </div>
  );
};

export default Input;
